// Remove the flash container before caching a page so that notifications
// won't appear when we restore the page
document.addEventListener("turbolinks:before-cache", function() {
  var flash_container = document.querySelector('div[data-flash-notifications]');
  if (flash_container) {
    flash_container.remove();
  }
});